// extracted by mini-css-extract-plugin
export default {"paper":"NotificationsSection_paper__QLBEP","header":"NotificationsSection_header__Bz7H4"};